import SetupIcon from "../../assets/icons/setup.svg";
import SecurityIcon from "../../assets/icons/security.svg";
import ProfileIcon from "../../assets/icons/ph_user.svg";
import AccountIcon from "../../assets/icons/ph_user_circle_gear.svg";
import SettingsIcon from "../../assets/icons/Settings-black.svg";

export type AccountCardTheme = {
  iconBg: string;
  iconColor: string;
  footerBg: string;
  footerText: string;
  footerHover: string;
};

export type AccountCardItem = {
  id: string;
  cardheading: string;
  cardtext: string;
  carButtonText: string;
  cardbuttonValue: string;
  theme: AccountCardTheme;
  items: { label: string; icon: string }[];
  cardIcon?: string;
};

export const AccountData: AccountCardItem[] = [
  {
    id: "1",
    cardIcon: SetupIcon,
    cardheading: "Organizations",
    cardtext:
      "Company details, branding, memberships, and multi-tenant org management.",
    carButtonText: "Manage Organization",
    cardbuttonValue: "Organization Setup",
    theme: {
      iconBg: "#ECFDF5",
      iconColor: "#059669",
      footerBg: "#ECFDF5",
      footerText: "#047857",
      footerHover: "#D1FAE5",
    },
    items: [
      { label: "Company Details", icon: "building" },
      { label: "Memberships", icon: "users" },
      { label: "Suspend / Activate", icon: "sliders" },
      { label: "Branding", icon: "globe" },
    ],
  },
  {
    id: "2",
    cardIcon: ProfileIcon,
    cardheading: "User Profile",
    cardtext: "Update your profile and personal preferences.",
    carButtonText: "Manage Profile",
    cardbuttonValue: "Profile",
    theme: {
      iconBg: "#DBEAFE",
      iconColor: "#2563EB",
      footerBg: "#DBEAFE",
      footerText: "#1D4ED8",
      footerHover: "#BFDBFE",
    },
    items: [
      { label: "Personal Information", icon: "user" },
      { label: "Email Preferences", icon: "mail" },
      { label: "Notifications", icon: "bell" },
      { label: "Language & Timezone", icon: "globe" },
    ],
  },
  {
    id: "3",
    cardIcon: SecurityIcon,
    cardheading: "Security",
    cardtext: "Manage password and advanced security settings.",
    carButtonText: "Manage Security",
    cardbuttonValue: "Security",
    theme: {
      iconBg: "#D1FAE5",
      iconColor: "#059669",
      footerBg: "#D1FAE5",
      footerText: "#047857",
      footerHover: "#A7F3D0",
    },
    items: [
      { label: "Password", icon: "lock" },
      { label: "Two-Factor Authentication", icon: "shield" },
      { label: "Login History", icon: "clock" },
      { label: "Active Sessions", icon: "monitor" },
    ],
  },
  {
    id: "4",
    cardIcon: AccountIcon,
    cardheading: "Roles & Permissions",
    cardtext: "Assign roles and manage user permissions.",
    carButtonText: "Manage Roles",
    cardbuttonValue: "Role",
    theme: {
      iconBg: "#FFEDD5",
      iconColor: "#EA580C",
      footerBg: "#FFEDD5",
      footerText: "#C2410C",
      footerHover: "#FED7AA",
    },
    items: [
      { label: "User Roles", icon: "badge" },
      { label: "Permissions", icon: "key" },
      { label: "Access Control", icon: "sliders" },
      { label: "Audit Logs", icon: "list" },
    ],
  },
  {
    id: "5",
    cardIcon: SettingsIcon,
    cardheading: "System Settings",
    cardtext: "Configure system preferences and integrations.",
    carButtonText: "Manage System",
    cardbuttonValue: "System Setting",
    theme: {
      iconBg: "#F9F0F4",
      iconColor: "#4338CA",
      footerBg: "#F9F0F4",
      footerText: "#3730A3",
      footerHover: "#D4B8C0",
    },
    items: [
      { label: "Email Configuration", icon: "mail" },
      { label: "Integrations", icon: "plug" },
      { label: "API Keys", icon: "code" },
      { label: "Backup & Restore", icon: "database" },
    ],
  },
  {
    id: "8",
    cardIcon: SettingsIcon,
    cardheading: "Org Integrations",
    cardtext: "Engage (AuthKey), Housing, 99acres, WhatsApp templates per org.",
    carButtonText: "Configure Integrations",
    cardbuttonValue: "Org Integrations",
    theme: {
      iconBg: "#F9F0F4",
      iconColor: "#841C39",
      footerBg: "#F9F0F4",
      footerText: "#3730A3",
      footerHover: "#F9F0F4",
    },
    items: [
      { label: "Engage / AuthKey", icon: "plug" },
      { label: "WhatsApp Templates", icon: "mail" },
      { label: "Housing / 99acres", icon: "code" },
      { label: "OTP Template", icon: "key" },
    ],
  },
  {
    id: "9",
    cardIcon: SecurityIcon,
    cardheading: "Audit Logs",
    cardtext: "Track what teams and users do across organizations.",
    carButtonText: "View Audit Logs",
    cardbuttonValue: "Audit Logs",
    theme: {
      iconBg: "#FEF3C7",
      iconColor: "#D97706",
      footerBg: "#FEF3C7",
      footerText: "#B45309",
      footerHover: "#FDE68A",
    },
    items: [
      { label: "Team Activity", icon: "list" },
      { label: "Org Changes", icon: "building" },
      { label: "Integrations", icon: "plug" },
      { label: "Filters", icon: "sliders" },
    ],
  },
  {
    id: "6",
    cardIcon: AccountIcon,
    cardheading: "CRM Preferences",
    cardtext: "Customize CRM experience as per your needs.",
    carButtonText: "Manage Preferences",
    cardbuttonValue: "Account Status",
    theme: {
      iconBg: "#FCE7F3",
      iconColor: "#DB2777",
      footerBg: "#FCE7F3",
      footerText: "#BE185D",
      footerHover: "#FBCFE8",
    },
    items: [
      { label: "Lead Settings", icon: "target" },
      { label: "Automation", icon: "zap" },
      { label: "Pipeline Settings", icon: "funnel" },
      { label: "Notifications", icon: "bell" },
    ],
  },
  {
    id: "7",
    cardIcon: SettingsIcon,
    cardheading: "Automation Lead Flow",
    cardtext:
      "Design lead capture, routing, WhatsApp, email, SMS, and IVR workflows.",
    carButtonText: "Open Automation",
    cardbuttonValue: "Automation Lead Flow",
    theme: {
      iconBg: "#F9F0F4",
      iconColor: "#4338CA",
      footerBg: "#F9F0F4",
      footerText: "#3730A3",
      footerHover: "#D4B8C0",
    },
    items: [
      { label: "Lead Capture", icon: "target" },
      { label: "Smart Routing", icon: "funnel" },
      { label: "WhatsApp / Email / SMS", icon: "mail" },
      { label: "IVR Call", icon: "zap" },
    ],
  },
];
